<template>
  <div>
    <NotifyBar />
    <GlobalLoader />
    <router-view />

    <!-- SYNC OVERLAY -->
    <div v-if="syncState.locked" class="sync-lock">
      <div class="sync-lock__card">
        <div class="sync-lock__title">Veriler güncelleniyor</div>
        <div class="sync-lock__msg">{{ syncState.message || 'Lütfen bekleyin...' }}</div>

        <div v-if="syncState.total > 0" class="sync-lock__progress">
          {{ syncState.processed }} / {{ syncState.total }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalLoader from "@/components/loader.vue";
import NotifyBar from "@/components/notifyBar.vue";
import syncService, { syncState } from "@/services/syncService";
import { createFxService } from "@/services/fxService";

const fx = createFxService({ endpointUrl: "https://api.projemikro.com/doviz" });
export default {
  name: "App",
  components: { GlobalLoader, NotifyBar },
  computed: {
    syncState() {
      return syncState;
    }
  },
  data() {
    return {
      _lastPath: null
    };
  },
created() {
  // İlk path’i kaydet
  this._lastPath = this.$route.path;

  // ✅ Tek-çağrı kilidi
  this._syncPromise = null;

  // ✅ Login sonrası "2. route değişimi" için cooldown
  this._postLoginSyncAt = 0;
  const POST_LOGIN_COOLDOWN_MS = 60 * 1000; // 60sn (istersen 15sn yap)

  const shouldCooldown = () => {
    if (!this._postLoginSyncAt) return false;
    return (Date.now() - this._postLoginSyncAt) < POST_LOGIN_COOLDOWN_MS;
  };

  const runSyncOnce = async (opts) => {
    // Zaten bir sync çağrısı başlatıldıysa yeni çağrıyı yut
    if (this._syncPromise) return;

    // syncService içi isRunning guard (aynı instance ise zaten korur)
    if (syncService.isRunning && typeof syncService.isRunning === "function") {
      if (syncService.isRunning()) return;
    }

    this._syncPromise = Promise.resolve()
      .then(() => syncService.setcariandstok(this.$request, opts))
      .catch((e) => {
        console.error("[APP] sync error:", e);
      })
      .finally(() => {
        this._syncPromise = null;
      });

    await this._syncPromise;
  };

  this.$watch(
    () => this.$route.fullPath,
    async () => {
      const toPath = this.$route.path;
      const fromPath = this._lastPath;
      this._lastPath = toPath;

      // 1) Login sayfasında sync ASLA çalışmasın
      if (toPath === "/login") return;

      // 2) Login değilse ama user yoksa sync çalışmasın
      const tfxm = localStorage.getItem("tfxm");
      if (!tfxm) return;

      // 3) Login'den yeni çıktıysa: force + lockUI
      if (fromPath === "/login" && toPath !== "/login") {
        await runSyncOnce({ force: true, lockUI: true });

        // ✅ Login sonrası sync bitti: hemen arkasından gelen route değişimlerinde tekrar sync yapma
        this._postLoginSyncAt = Date.now();
        return;
      }

      // 4) Login sonrası cooldown içindeysek: tekrar sync tetikleme
      if (shouldCooldown()) return;

      // 5) Diğer route geçişlerinde: sadece kontrol, kilit yok
      await runSyncOnce({ force: false, lockUI: false });
    },
    { immediate: true }
  );
    fx.get().catch(() => {});

    // 2) lifecycle: visible/online olunca kontrol + 15:30 scheduler
    fx.attachLifecycle();

    // 3) (opsiyonel) UI bir yerde kuru canlı gösterecekse:
    // fx.subscribe((payload) => console.log("FX updated", payload));

},
  beforeDestroy() {
    fx.destroy();
  },  

};
</script>

<style>
.sync-lock {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}
.sync-lock__card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  width: 380px;
  max-width: calc(100% - 24px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}
.sync-lock__title { font-size: 16px; font-weight: 600; }
.sync-lock__msg { margin-top: 6px; font-size: 13px; line-height: 1.4; opacity: .9; }
.sync-lock__progress { margin-top: 10px; font-size: 12px; opacity: .85; }
</style>



// WEBPACK FOOTER //
// src/App.vue